import React from 'react';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import ArrowDownIcon from '../../../../Icons/ArrowDown';
import withCurrentMediaSource from '../../../_hocs/withCurrentMediaSource';
import s from './MediaSourceMenuMobile.scss';
import { getTransKeyForMediaSourceType, getAllMediaSourceTypes, } from '../_helpers';
var enhance = compose(withCurrentMediaSource);
export var MediaSourceMenu = function (_a) {
    var currentMediaSource = _a.currentMediaSource, mediaSourceTypes = _a.mediaSourceTypes, changeCurrentMediaSource = _a.changeCurrentMediaSource;
    var t = useTranslation().t;
    return (React.createElement("div", { className: s['root'] },
        t(getTransKeyForMediaSourceType(currentMediaSource)),
        React.createElement(ArrowDownIcon, { className: s['icon'] }),
        React.createElement("select", { value: currentMediaSource, onChange: function (event) {
                return changeCurrentMediaSource(event.target.value);
            } }, (mediaSourceTypes || getAllMediaSourceTypes()).map(function (mediaSourceType, key) {
            return (React.createElement("option", { key: key, value: mediaSourceType }, t(getTransKeyForMediaSourceType(mediaSourceType))));
        }))));
};
MediaSourceMenu.displayName = 'MediaSourceMenu';
export default enhance(MediaSourceMenu);
//# sourceMappingURL=MediaSourceMenuMobile.connected.js.map